module.exports = __webpack_public_path__ + "img/12.3db6edad.png";